module.exports = __webpack_public_path__ + "img/info-kiosk.8e05cfa4.jpg";